import { TResetAppCacheStore } from '@monorepo/types';
import { TResetAppCacheStoreActions } from './reset-app-cache-db.actions';

export function getResetAppCacheStoreInitalState(): TResetAppCacheStore {
  return {};
}

export const resetAppCacheStoreInitalState: TResetAppCacheStore = getResetAppCacheStoreInitalState();

export function ResetAppCacheStoreStateReducer(
  state: TResetAppCacheStore = resetAppCacheStoreInitalState,
  _action: TResetAppCacheStoreActions,
): TResetAppCacheStore {
  return state;
}
